module.exports = __webpack_public_path__ + "static/media/USDD.ad0ab928.png";